import { Component, OnInit, Input } from '@angular/core';
import { HtmlBase, PropertyData } from '../../../../models';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-radio-bouton',
  templateUrl: './radio-bouton.component.html',
  styleUrls: ['./radio-bouton.component.css']
})
export class RadioBoutonComponent implements OnInit {

  public uuid: string = Math.random().toString(36).substring(2) + (new Date()).getTime().toString(36);

  @Input('input') input: PropertyData;

  constructor() { }

  ngOnInit(): void { }

  public SetResponse(question: HtmlBase, value: string): void {
    question.SelectOptionsList.forEach(reponse => {
      reponse.Selected = reponse.Value == value && !reponse.Selected;
    });
  }
}
